import {
  DeleteLocationDocument,
  DeleteLocationMutation,
  DeleteLocationMutationVariables,
  GetLocationsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteLocation = () => {
  const [executeMutation] = useMutation(DeleteLocationDocument, {
    extractorFn: (data: DeleteLocationMutation) => data.locationsMutations.deleteLocationsLocation,
  })

  const deleteLocation = async (variables: DeleteLocationMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [
        {
          query: GetLocationsDocument,
        },
      ],
    })
  }

  return {
    deleteLocation,
  }
}
